export const isPrefetch = (): boolean => {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get("prefetch") === "true";
};